/* eslint-disable no-undef */
// eslint-disable-next-line no-unused-vars

import * as MathUtils from '../../utils/MathUtils.js'
import { CurrentLang } from 'common';
//import { MagstimColor } from "./../Magstim.Color";
import * as StringUtils from '../../utils/StringUtils.js'

function __getUniqueOptions(array, propertyName) {
    var retVal = [];
    for (var x = 0; x < array.length; x++) {
        var element = array[x];
        //console.log(`__getUniqueOptions element=${JSON.stringify(element, null, 4)}`);
        if ((undefined === element.__dummy_no_data_row) || (null === element.__dummy_no_data_row) || !element.__dummy_no_data_row) {
            var value = element[propertyName];
            if ((undefined !== value) && (null !== value) && !retVal.includes(value)) {
                retVal.push(value);
            }
        }
    }

    //retVal.sort();
    retVal.sort((lhs, rhs) => lhs.localeCompare(rhs, undefined, { sensitivity: 'base' }));

    //console.log(`__getUniqueOptions array=${JSON.stringify(array, null, 4)} propertyName=${propertyName} retVal=${JSON.stringify(retVal, null, 4)}`);
    //console.log(`__getUniqueOptions array=${array} propertyName=${propertyName} retVal=${JSON.stringify(retVal, null, 4)}`);
    return retVal;
}

function __addSelectOption(select, text, value) {
    var elem = document.createElement('option');
    elem.text = text;
    elem.value = value; // null gets converted to a string
    select.add(elem);
}

function __populateSelect(select, array) {

    array.sort();

    __addSelectOption(select, "All", ''); // Localise

    for (var i = 0; i < array.length; i++) {
        __addSelectOption(select, array[i], array[i]);
    }
}

export function populateSelect(divTable, select, propertyName) {
    if (typeof select === 'string' || select instanceof String) {
        select = document.getElementById(select);
    }
    var table = __getTable(divTable);
    var array = __getUniqueOptions(table.__tableData.data, propertyName);
    __populateSelect(select, array);
    select.onchange = __createSelectChangeHandler(table, select, propertyName);
}

function __addDropdownItem(divMenu, value, tableID) {
    let elem = document.createElement('a');
    elem.text = value;
    //elem.value = value; // null gets converted to a string
    elem.id = value;
    //elem.href = '#';
    elem.className = 'dropdown-item';
    elem.role = 'button';
    elem.onclick = __createDropdownChangeHandler(tableID, divMenu.id, value);
    return elem;
}

function __populateDropdown(divMenu, array, defaultVal, tableID) {

    array.sort();

    let menuItems = [];

    let divider = document.createElement('div');
    divider.className = "dropdown-divider";
    divider.role = "separator";

    let defaultItem = document.createElement('a');
    defaultItem.id = "";
    defaultItem.href = "#";
    defaultItem.className = "dropdown-item";
    defaultItem.role = "button";
    defaultItem.text = defaultVal;

    // __addDropdownItem(divMenu, "All", ''); // Localise
    menuItems.push(defaultItem);
    menuItems.push(divider);

    for (let i = 0; i < array.length; i++) {
        menuItems.push(__addDropdownItem(divMenu, array[i], tableID));
    }

    divMenu.innerHTML = "";

    for (let j = 0; j < menuItems.length; j++) {
        divMenu.appendChild(menuItems[j]);
    }
}

export function populateDropdown(divTable, divMenu, propertyName) {

    var defaultVal = '';

    if (typeof divMenu === 'string' || divMenu instanceof String) {
        defaultVal = document.getElementById('default_' + divMenu).text;
        divMenu = document.getElementById(divMenu);
    }

    var table = __getTable(divTable);
    var array = __getUniqueOptions(table.__tableData.data, propertyName);

    __populateDropdown(divMenu, array, defaultVal, divTable);
}

export function getDropdownItems(divTable, divMenu, propertyName) {
    //console.log(`getDropdownItems divTable=${divTable} divMenu=${divMenu} propertyName=${propertyName}`);
    return __getUniqueOptions(__getTable(divTable).__tableData.data, propertyName);
}

export function setFilter(divTable, propertyName, propertyValue) {
    const elemTable = __getTable(divTable);

    elemTable.__SearchText = null;
    elemTable.__Filters = {};
    elemTable.__Filters[propertyName] = propertyValue;

    log(elemTable, `setFilter(${divTable},${propertyName},${propertyValue})`);

    __refreshRowsWithGlobalFilters(elemTable);
}

export function addFilter(divTable, propertyName, propertyValue) {
    const elemTable = __getTable(divTable);

    if (undefined === elemTable.__Filters) {
        elemTable.__Filters = {};
    }
    elemTable.__Filters[propertyName] = propertyValue;

    // log(elemTable, `addFilter(${divTable},${propertyName},${propertyValue})`);

    __refreshRowsWithGlobalFilters(elemTable);
}

function __handleSelectChange(elemTable, select, propertyName) {
    addFilter(elemTable, propertyName, select.selectedOptions[0].value);
}

function __createSelectChangeHandler(elemTable, select, propertyName) {
    return function () {
        __handleSelectChange(elemTable, select, propertyName);
    };
}

function __handleDropdownChange(elemTable, dropdownItem, propertyName) {
    addFilter(elemTable, dropdownItem, propertyName);
}

function __createDropdownChangeHandler(elemTable, propertyName, dropdownItem) {
    return function () {
        __handleDropdownChange(elemTable, propertyName, dropdownItem)
        //console.log(elemTable, dropdownItem, propertyName);
    };
}

function __createElement(elementType, className, innerText) {
    var element = document.createElement(elementType);

    if ((undefined !== className) && (null !== className)) {
        element.className = className;
    }

    if ((undefined !== innerText) && (null !== innerText)) {
        element.innerText = innerText;
    }

    return element;
}

//#region Sort

const __SORT = 'fas fa-sort fa-lg';
const __SORT_UP = 'fas fa-sort-up fa-lg';
const __SORT_DOWN = 'fas fa-sort-down fa-lg';

function __convertToSortableValue(value) {
    if ((undefined === value) || (null === value)) {
        return value;
    }
    else if ((undefined !== value.numerator) && (undefined !== value.denominator)) {
        return Number(value.numerator) / Number(value.denominator);
    }
    else if ((value instanceof String) || (typeof value === 'string'))
    {
        return value.toLowerCase(); // case insensetive sorting
    }
    else {
        return value;
    }
}

function __sort(elemTable, elemSort, column, alwaysSortedColumn, customSortClickHandler) {
    //var t0 = performance.now();

    // console.log(`__sort`, column, alwaysSortedColumn, customSortClickHandler);

    var direction = 1;
    if ((elemSort.className === __SORT) || (elemSort.className === __SORT_UP)) {
        direction = 1;
        elemSort.className = __SORT_DOWN;
    }
    else {
        direction = -1;
        elemSort.className = __SORT_UP;
    }

    if (undefined !== customSortClickHandler) {
        
        __sortData(elemTable.__tableData.rawData, column.property, direction, alwaysSortedColumn);
        elemTable.__tableData.data = customSortClickHandler(elemTable.__tableData, column, alwaysSortedColumn, direction);
    }

    for (var columnNum = 0; columnNum < elemTable.__sortButtons.length; columnNum++) {
        if (elemSort !== elemTable.__sortButtons[columnNum]) {
            elemTable.__sortButtons[columnNum].className = __SORT;
        }
    }

    var columnProperty;

    if (elemTable.__tableData.data.isGrouped) {
        columnProperty = 'groupName';
    }
    else {
        columnProperty = column.property;
    }

    __sortData(elemTable.__tableData.data, columnProperty, direction, alwaysSortedColumn);

    __refreshRowsWithGlobalFilters(elemTable);
}

function __sortData(data, columnProperty, direction, alwaysSortedColumn) {
    data.sort(function (lhs, rhs) {
        const valueLhs = __convertToSortableValue(lhs[columnProperty]);
        const valueRhs = __convertToSortableValue(rhs[columnProperty]);
        if (lhs === rhs)
            return 0;
        else if (null === valueLhs)
            return 1;
        else if (null === valueRhs)
            return -1;
        else if (valueLhs > valueRhs)
            return direction;
        else if (valueLhs < valueRhs)
            return -direction;
        else
            return 0;
    });

    if ((undefined !== alwaysSortedColumn) && (null !== alwaysSortedColumn) && (alwaysSortedColumn.property !== columnProperty)) {
        var alwaysSortedColumnProperty = alwaysSortedColumn.property;
        var alwaysSortedDirection = alwaysSortedColumn.alwaysSortedDirection;
        data.sort(function (lhs, rhs) {
            const valueLhs = __convertToSortableValue(lhs[alwaysSortedColumnProperty]);
            const valueRhs = __convertToSortableValue(rhs[alwaysSortedColumnProperty]);
            if (undefined === valueRhs)
                return alwaysSortedDirection;
            else if (undefined === valueLhs)
                return -alwaysSortedDirection;
            else if (valueLhs > valueRhs)
                return alwaysSortedDirection;
            else if (valueLhs < valueRhs)
                return -alwaysSortedDirection;
            else
                return 0;
        });
    }
}

function __createSortClickHandler(elemTable, elemSort, column, alwaysSortedColumn, customSortClickHandler) {
    return function () {
        __sort(elemTable, elemSort, column, alwaysSortedColumn, customSortClickHandler);
    };
}

//#endregion



//#region Privacy  

const __PRIVACY_CHECKED_ICON = 'far fa-eye-slash fa-lg';
const __PRIVACY_UNCHECKED_ICON = 'far fa-eye fa-lg';

function __handlePrivacyClick(elemPrivacy, elemTable, tablePrivacyModeChangedHandler) {

    if ((undefined !== elemPrivacy) && (null !== elemPrivacy)) {
        elemTable.__privacyModeOn = (elemPrivacy.className === __PRIVACY_CHECKED_ICON);
        elemTable.__privacyModeOn = !elemTable.__privacyModeOn; // Handle click

        __updatePrivacyImage(elemPrivacy, elemTable.__privacyModeOn);

        __refreshRowsWithGlobalFilters(elemTable);

        if(tablePrivacyModeChangedHandler){
            tablePrivacyModeChangedHandler( elemTable.__privacyModeOn);
        }
    }
}

function __createPrivacyClickHandler(elemPrivacy, elemTable, tablePrivacyModeChangedHandler) {
    return function () {
        __handlePrivacyClick(elemPrivacy, elemTable, tablePrivacyModeChangedHandler);
    };
}

function __updatePrivacyImage(elemPrivacy, isSelected) {
    if ((undefined !== elemPrivacy) && (null !== elemPrivacy)) {
        elemPrivacy.className = isSelected ? __PRIVACY_CHECKED_ICON : __PRIVACY_UNCHECKED_ICON;
    }
}

function __addPrivacyColumn(tableHeadRow, elemTable, tablePrivacyModeChangedHandler) {
    var i = null;
    var th = document.createElement('th');
    var span = __createElement('span');
    span.style = 'right: 5px';
    i = __createElement('i');
    elemTable.__privacyModeOn = true;
    __updatePrivacyImage(i, elemTable.__privacyModeOn);
    i.addEventListener('click', __createPrivacyClickHandler(i, elemTable, tablePrivacyModeChangedHandler));
    span.appendChild(i);
    th.appendChild(span);
    tableHeadRow.appendChild(th);
    return i;
}

//#endregion



//#region Select

var __SELECT_ALL_CHECKED_ICON = 'fas fa-check-square';
var __SELECT_ALL_UNCHECKED_ICON = 'fas fa-square';

function __handleCheckAllClick(elemCheckAll, rows, selectSettings, tableSelectionChangedHandler) {

    // console.log(`#MAGS-1599 __handleCheckAllClick rows = `, rows);
    const tables = document.getElementsByTagName('table');
    if ((undefined !== tables) && (null !== tables) && (tables.length > 0)) {
        const table = tables[0];    
        if (null !== table) {
            const __tableData = table.__tableData;
            if ((undefined !== __tableData) && (null !== __tableData)) {
                const filteredData = __tableData.filteredData;
                if ((undefined !== filteredData) && (null !== filteredData)) {
                    rows = filteredData;
                }
            }
        }
    }
    // console.log(`#MAGS-1599 __handleCheckAllClick rows = `, rows);

    if ((undefined !== elemCheckAll) && (null !== elemCheckAll)) {
        var isSelected = (elemCheckAll.className === __SELECT_ALL_CHECKED_ICON);
        isSelected = !isSelected; // Handle click

        __updateCheckAllImage(elemCheckAll, isSelected);

        for (var rowNum = 0; rowNum < rows.length; rowNum++) {
            var row = rows[rowNum];
            row.__isSelected = isSelected;
            __updateCheckImage(row.__checkButton, isSelected, selectSettings);
        }
    }

    if (tableSelectionChangedHandler) {
        tableSelectionChangedHandler("__handleCheckAllClick", isSelected, rows);
    }
}

function __handleCheckClick(row, elemCheckAll, rows, selectSettings, multiselect, tableSelectionChangedHandler) {

    // console.log('__handleCheckClick');

    if (!multiselect) {
        // Clear any other selected rows in single select mode...
        for (var rowNum = 0; rowNum < rows.length; rowNum++) {
            if (rows[rowNum].__isSelected) {
                rows[rowNum].__isSelected = false;
                __updateCheckImage(rows[rowNum].__checkButton, false, selectSettings);
            }
        }
    }

    row.__isSelected = !row.__isSelected;
    __updateCheckImage(row.__checkButton, row.__isSelected, selectSettings);

    if (multiselect) {
        __updateCheckAll(elemCheckAll, rows);
    }

    if (tableSelectionChangedHandler) {
        tableSelectionChangedHandler("__handleCheckClick", row.__isSelected, rows, row);
    }
}

function __createCheckAllClickHandler(elemCheckAll, rows, selectSettings, tableSelectionChangedHandler) {
    return function () {
        __handleCheckAllClick(elemCheckAll, rows, selectSettings, tableSelectionChangedHandler);
    };
}

function __createCheckClickHandler(row, elemCheckAll, rows, selectSettings, multiselect, tableSelectionChangedHandler) {
    return function () {
        __handleCheckClick(row, elemCheckAll, rows, selectSettings, multiselect, tableSelectionChangedHandler);
    };
}

function __updateCheckAllImage(elemCheckAll, isSelected) {
    if ((undefined !== elemCheckAll) && (null !== elemCheckAll)) {
        elemCheckAll.className = isSelected ? __SELECT_ALL_CHECKED_ICON : __SELECT_ALL_UNCHECKED_ICON;
    }
}

function __updateCheckImage(elemCheck, isSelected, selectSettings) {
    var settings = isSelected ? selectSettings.checked : selectSettings.unchecked;
    elemCheck.className = settings.icon;
    elemCheck.style.color = settings.color;
}

function __updateCheckAll(elemCheckAll, rows) {

    var allSelected = true;

    for (var rowNum = 0; rowNum < rows.length; rowNum++) {
        var row = rows[rowNum];

        allSelected = allSelected & row.__isSelected;

        if (!allSelected) {
            break;
        }
    }

    __updateCheckAllImage(elemCheckAll, allSelected);
}

function __addSelectColumn(tableHeadRow, rows, selectSettings, tableSelectionChangedHandler) {

    var elemCheckAll = null;

    var th = document.createElement('th');
    th.className = 'select-header';
    var span = __createElement('span');
    elemCheckAll = __createElement('i');
    __updateCheckAllImage(elemCheckAll, false);
    elemCheckAll.addEventListener('click', __createCheckAllClickHandler(elemCheckAll, rows, selectSettings, tableSelectionChangedHandler));
    span.appendChild(elemCheckAll);
    span.appendChild(__createElement('i', 'fas fa-list'));
    th.appendChild(span);
    tableHeadRow.appendChild(th);

    return elemCheckAll;
}

function __addSelectCell(elemTable, elemRow, row, elemCheckAll, rows) {

    if (undefined === row.__isSelected) {
        row.__isSelected = false;
    }

    var td = document.createElement('td');
    td.className = 'select-cell';

    var elemCheck = __createElement('i');
    row.__checkButton = elemCheck;
    __updateCheckImage(elemCheck, row.__isSelected, elemTable.__tableData.select);
    elemCheck.addEventListener('click', __createCheckClickHandler(row, elemCheckAll, rows, elemTable.__tableData.select, elemTable.__tableData.multiselect, elemTable.__tableData.tableSelectionChangedHandler));
    td.appendChild(elemCheck);
    elemTable.__checkButtons.push(elemCheck);

    elemRow.appendChild(td);

    return elemCheck;
}

//#endregion

function __setupSelectColumnHeaders(elemTable, tableHeadRow, columns) {
    if (elemTable.__tableData.multiselect) {
        elemTable.__checkAllButton = __addSelectColumn(tableHeadRow, elemTable.__tableData.data, elemTable.__tableData.select, elemTable.__tableData.tableSelectionChangedHandler);
    }
}

function __setupColumnHeaders(elemTable, tableHeadRow, columns) {

    // console.log(`MagstimTable.__setupColumnHeaders`, elemTable, tableHeadRow, columns);

    elemTable.__sortButtons = [];

    elemTable.__tableData.privacyMode = false;

    var column = null;
    var alwaysSortedColumn = null;

    var columnNum = 0;

    for (columnNum = 0; columnNum < columns.length; columnNum++) {
        column = columns[columnNum];

        if ((undefined !== column.alwaysSortedDirection) && (null !== column.alwaysSortedDirection) && (0 !== column.alwaysSortedDirection)) {
            alwaysSortedColumn = column;
        }
    }

    if(elemTable.__tableData.showSelectAtStart === true){
        __setupSelectColumnHeaders(elemTable, tableHeadRow, columns)
    }

    for (columnNum = 0; columnNum < columns.length; columnNum++) {

        column = columns[columnNum];

        const isHidden = (undefined !== column.isHidden) && (null !== column.isHidden) && column.isHidden;
        const isExportOnly = (undefined !== column.isExportOnly) && (null !== column.isExportOnly) && column.isExportOnly;

        if (!isHidden && !isExportOnly) {

            if ((undefined !== column.isPrivate) && column.isPrivate) {
                elemTable.__tableData.privacyMode = true;
            }

            const th = document.createElement('th');

            if (undefined !== column.width) {
                th.style.width = column.width;
            }

            const span = __createElement('span', null, null);
            const headerDiv = __createElement('div', null, column.title);

            if ((undefined === column.sortable) || column.sortable) {
                const elemSort = __createElement('i', __SORT);
                const handler = __createSortClickHandler(elemTable, elemSort, column, alwaysSortedColumn, elemTable.__tableData.customSortClickHandler);
                headerDiv.addEventListener('click', handler);
                headerDiv.appendChild(elemSort);
                elemTable.__sortButtons.push(elemSort);
            }

            span.appendChild(headerDiv);

            th.appendChild(span);

            tableHeadRow.appendChild(th);
        }

    }

    if(elemTable.__tableData.showSelectAtStart === false){
        __setupSelectColumnHeaders(elemTable, tableHeadRow, columns)
    }

    if (elemTable.__tableData.privacyMode) {
        elemTable.__makePrivateButton = __addPrivacyColumn(tableHeadRow, elemTable, elemTable.__tableData.tablePrivacyModeChangedHandler);
    }
}

function __addDummyCell(tr, title) {
    var td = __createElement('td', null, title);
    td.className = 'dummy-cell';
    tr.appendChild(td);
}

// We add a dummy that contains the column titles, as they aren't taken into account when sizing the column width
function __addDummyRow(tableBody, columns, rowSelect, privacyMode, showSelectAtStart) {

    var tr = document.createElement('tr');
    tr.className = 'dummy-row';

    //tr.style.borderColor = 'transparent';

    if (rowSelect) {
        if(showSelectAtStart === true){
            __addDummyCell(tr, '&&&&'); // __addDummyRow rowSelect
        }
    }

    for (var columnNum = 0; columnNum < columns.length; columnNum++) {

        const column = columns[columnNum];

        const isHidden = (undefined !== column.isHidden) && (null !== column.isHidden) && column.isHidden;
        const isExportOnly = (undefined !== column.isExportOnly) && (null !== column.isExportOnly) && column.isExportOnly;

        if (!isHidden && !isExportOnly) {
            __addDummyCell(tr, columns[columnNum].title + '&&'); // __addDummyRow
        }
    }

    if (rowSelect) {
        if(showSelectAtStart === false){
            __addDummyCell(tr, '&&&&'); // __addDummyRow rowSelect
        }
    }

    if (privacyMode) {
        __addDummyCell(tr, '&'); // __addDummyRow privacyMode
    }

    tableBody.appendChild(tr);
}

function __refreshRowsWithGlobalFilters(elemTable) {
    // log(elemTable, '__refreshRowsWithGlobalFilters');
    __refreshRows(elemTable, elemTable.__SearchText, elemTable.__Filters);
}

function __refreshRows(elemTable, searchText, filters) {

    var tableBody = document.createElement('tbody');

    // Replace the body with an empty one that we re-fill
    elemTable.replaceChild(tableBody, elemTable.getElementsByTagName('tbody')[0]);

    __setupRows(elemTable, tableBody, searchText, filters, elemTable.__tableData.isGrouped, elemTable.__tableData.addNoDataWhenEmpty);
}

//function __handleRowClick(tr, row) {
//    if ((typeof tableHandler !== 'undefined') && (null !== this.tableHandler)) {
//    this.tableHandler.handleRowClick(JSON.stringify(row));
//    }
//}

//function __createRowClickHandler(tr, row) {
//    return function() {
//        __handleRowClick(tr, row);
//    };
//}


function __handleCellClick(tr, row, td, column, tableCellClickHandler) {

    if ((undefined === row.__dummy_no_data_row) || (null === row.__dummy_no_data_row) || (true !== row.__dummy_no_data_row) ) {
        
        // console.log('__handleCellClick : row = ' + JSON.stringify(row));
        // console.log('__handleCellClick : column = ' + JSON.stringify(column));

        var cell = null;
        if ((undefined !== column) && (null != column)) {
            // console.log('__handleCellClick : column.property = ' + column.property);
            // console.log('__handleCellClick : row[column.property] = ' + row[column.property]);
            cell = row[column.property];
        }
        // console.log('__handleCellClick : cell = ' + JSON.stringify(cell));

        if ((typeof tableHandler !== 'undefined') && (null !== tableHandler)) {
            tableHandler.handleCellClick(JSON.stringify(row), JSON.stringify(column), cell);
        }

        if(tableCellClickHandler){
            tableCellClickHandler(row, column, cell);
        }
    }
}

function __createCellClickHandler(tr, row, td, column, tableCellClickHandler) {
    return function () {
        __handleCellClick(tr, row, td, column, tableCellClickHandler);
    };
}

function __addGroupRow(tableBody, groupData, elemTable) {

    var tr = document.createElement('tr');
    tr.className = 'group-header'
    var td = document.createElement('td');
    td.innerText = groupData.groupName;
    td.onclick = __createCellClickHandler(tr, groupData, td, null, elemTable.__tableData.tableCellClickHandler);

    var column = null;

    var columnSpan = 0;
    for (var x = 0; x < elemTable.__tableData.columns.length; x++) {
        column = elemTable.__tableData.columns[x];
        if (undefined === column.groupedColumn || !column.groupedColumn) {

            const isHidden = (undefined !== column.isHidden) && (null !== column.isHidden) && column.isHidden;
            const isExportOnly = (undefined !== column.isExportOnly) && (null !== column.isExportOnly) && column.isExportOnly;
    
            if (!isHidden && !isExportOnly) {
                columnSpan++;
            }
        }
        else {
            break;
        }
    }

    td.colSpan = columnSpan;
    td.bgcolor = '#ff0000'
    tr.appendChild(td);

    for (; x < elemTable.__tableData.columns.length; x++) {
        column = elemTable.__tableData.columns[x];
        if (column.groupedColumn) {
            __addCell(elemTable, tr, groupData, column);
        }
        else {
            __addDummyCell(tr, ''); // __addGroupRow
        }
    }

    if (elemTable.__tableData.rowSelect) {
        __addSelectCell(elemTable, tr, groupData, elemTable.__checkAllButton, elemTable.__tableData.data);
    }

    if (elemTable.__tableData.privacyMode) {
        __addDummyCell(tr, '&'); // __addGroupRow privacyMode
    }

    tableBody.appendChild(tr);
}

function __setupRows(elemTable, tableBody, searchText, filters, isGrouped, addNoDataWhenEmpty) {

    elemTable.__checkButtons = [];

    // var trs = null;
    // if (!createElements) {
    //     // HTMLCollection is stupdily slow to access, so convert to an array
    //     trs = Array.prototype.slice.call( tableBody.getElementsByTagName('tr') );
    //     // trs = tableBody.getElementsByTagName('tr');
    // }

    if ((undefined !== searchText) && (null !== searchText)) {
        searchText = searchText.toLowerCase();
    }

    if ((undefined !== isGrouped) && (null !== isGrouped) && isGrouped) {

        for (var rowNum = 0; rowNum < elemTable.__tableData.data.length; rowNum++) {

            const groupData = elemTable.__tableData.data[rowNum];

            for (var childRowNum = 0; childRowNum < groupData.data.length; childRowNum++) {
                groupData.data[childRowNum].groupParent = groupData.groupName;
            }

            groupData.filteredData = __searchAndFilterRows(elemTable.__tableData.columns, groupData.data, searchText, filters);

            if (addNoDataWhenEmpty || (groupData.filteredData.length > 0)) {
                __addGroupRow(tableBody, groupData, elemTable);
                __populateRows(groupData.filteredData, groupData.data, false, elemTable, tableBody, isGrouped, addNoDataWhenEmpty);
            }

            //console.log(`__setupRows searchText=${searchText} isGrouped=${isGrouped} rowNum=${rowNum} groupData.groupName=${groupData.groupName}`, groupData.data, groupData.filteredData);
        }

    }
    else {
        elemTable.__tableData.filteredData = __setupRowsImpl(elemTable.__tableData.data, elemTable.__tableData.rowSelect, elemTable, tableBody, searchText, filters, isGrouped);
    }

    // console.log(`#MAGS-1599 __setupRows searchText = ${searchText} elemTable.__tableData.filteredData = `, elemTable.__tableData.filteredData);

    __addDummyRow(tableBody, elemTable.__tableData.columns, elemTable.__tableData.rowSelect, elemTable.__tableData.privacyMode, elemTable.__tableData.showSelectAtStart);
}

function __populateCell(elemTable, tr, row, td, column, tableCellClickHandler) {

    td.onclick = __createCellClickHandler(tr, row, td, column, tableCellClickHandler);

    var contentOriginal = row[column.property];
    var content = null;

    if (column.optional && ((undefined === contentOriginal) || (null === contentOriginal))) {
        if ((undefined === column.missingData) || (null === column.missingData)) {
            content = '';
        }
        else {
            content = column.missingData;
        }
    }
    else {
        if ((undefined !== column.formatter) && (null !== column.formatter)) {
            content = column.formatter(contentOriginal, column, row);
        }
        else {
            content = contentOriginal;
        }
    }

    row.__privacyModeOn = elemTable.__privacyModeOn;

    if (elemTable.__privacyModeOn && (undefined !== column.isPrivate) && column.isPrivate) {
        content = StringUtils.AnonymiseString(contentOriginal);
    }

    if (typeof content === 'string' || content instanceof String) {
        td.innerText = content;
    }
    else if (typeof content === 'number') {
        td.innerText = MathUtils.sanitiseNum(content);
    }
    else if (content === undefined || content === null) {
        td.innerText = CurrentLang().no_data_words;
    }
    else {
        td.appendChild(content);
    }
}

function __addCell(elemTable, tr, row, column) {
    if (!column.isExportOnly) {
        const td = document.createElement('td');
        td.className = 'data-cell';
        td.setAttribute('data-testid', 'table-cell');
        td.setAttribute('data-title', column.title);

        var style = 'word-break:break-word;';
        if (undefined !== row.__foregroundColor) {
            style += ` color:${row.__foregroundColor}`;
        }

        td.setAttribute('style', style);
        __populateCell(elemTable, tr, row, td, column, elemTable.__tableData.tableCellClickHandler);
        tr.appendChild(td);
    }
}

function __populateSelectCell(tr, row, data, rowSelect, elemTable, isGrouped) {

    if (elemTable.__tableData.rowSelect) {

        if (rowSelect) {
            __addSelectCell(elemTable, tr, row, elemTable.__checkAllButton, data);
        }
        else {
            __addDummyCell(tr, '&'); // __populateRow !rowSelect
        }

    }
}

function __populateRow(tr, row, data, rowSelect, elemTable, isGrouped) {

    if(elemTable.__tableData.showSelectAtStart === true){
        __populateSelectCell(tr, row, data, rowSelect, elemTable, isGrouped);
    }

    for (var columnNum = 0; columnNum < elemTable.__tableData.columns.length; columnNum++) {
        const column = elemTable.__tableData.columns[columnNum];

        const isHidden = (undefined !== column.isHidden) && (null !== column.isHidden) && column.isHidden;
        const isExportOnly = (undefined !== column.isExportOnly) && (null !== column.isExportOnly) && column.isExportOnly;

        if (!isHidden && !isExportOnly) {

            if (isGrouped && column.groupedColumn) {
                __addDummyCell(tr, ''); // __populateRow
            }
            else {
                __addCell(elemTable, tr, row, column);
            }
        }
    }

    if(elemTable.__tableData.showSelectAtStart === false){
        __populateSelectCell(tr, row, data, rowSelect, elemTable, isGrouped);
    }


    if (elemTable.__tableData.privacyMode) {
        __addDummyCell(tr, '&'); // __populateRow privacyMode
    }
}

function __searchInRowForSearchPart(columns, row, searchPart) {

    // If any of the searchable columns match the searchPart, return true...

    for (var columnNum = 0; columnNum < columns.length; columnNum++) {
        const column = columns[columnNum];
        if ((undefined !== column.isSearchable) && column.isSearchable) {
            if (row[column.property].toLowerCase().includes(searchPart)) {
                return true;
            }
        }
    }

    return false;
}

function __searchInRowForSearchParts(columns, row, searchParts) {

    // If all of the searchParts are found, return true...

    for (var searchPartNum = 0; searchPartNum < searchParts.length; searchPartNum++) {
        if (!__searchInRowForSearchPart(columns, row, searchParts[searchPartNum])) {
            return false;
        }
    }

    return true;
}

function __searchInRowForFilters(columns, row, filters) {

    for (var columnNum = 0; columnNum < columns.length; columnNum++) {
        const column = columns[columnNum];

        const filter = filters[column.property];

        if ((undefined !== filter) && (null !== filter)) {
            if ((typeof filter === 'string' || filter instanceof String) && (filter.length > 0)) {
                if (!(row[column.property] === filter)) {
                    return false;
                }
            }
            else if ((undefined !== filter.start) && (undefined !== filter.end)) {
                if (!(row[column.property] >= filter.start) && (row[column.property] <= filter.end)) {
                    return false;
                }
            }
        }
    }

    return true;
}

function __searchInRow(columns, row, searchText, filters) {

    var match = true;

    if ((undefined !== searchText) && (null !== searchText)) {
        match = __searchInRowForSearchParts(columns, row, searchText.split(" "))
    }

    if (match && (filters !== undefined) && (filters !== null)) {
        match = __searchInRowForFilters(columns, row, filters);
    }

    return match;

}

function __searchAndFilterRows(columns, rows, searchText, filters) {

    var filteredData = [];

    for (var rowNum = 0; rowNum < rows.length; rowNum++) {
        const row = rows[rowNum];
        if (__searchInRow(columns, row, searchText, filters)) {
            filteredData.push(row);
        }
    }

    return filteredData;
}

function __populateRows(filteredData, data, rowSelect, elemTable, tableBody, isGrouped, addNoDataWhenEmpty) {
    if (filteredData.length > 0) {
        for (var rowNum = 0; rowNum < filteredData.length; rowNum++) {
            const row = filteredData[rowNum];
            const tr = document.createElement('tr');
            tr.className = 'data-row';
            
            if ((undefined !== row.__backgroundColor) && (undefined !== row.__foregroundColor)) {
                tr.style = `background: ${row.__backgroundColor}`;
            }

            __populateRow(tr, row, data, rowSelect, elemTable, isGrouped);
            tableBody.appendChild(tr);
        }
    }
    else if (addNoDataWhenEmpty) {
        const row = {};
        const tr = document.createElement('tr');
        tr.className = 'data-row';
        __populateRow(tr, row, data, rowSelect, elemTable, isGrouped);
        tableBody.appendChild(tr);
    }
}

function __setupRowsImpl(data, rowSelect, elemTable, tableBody, searchText, filters, isGrouped) {
    const filteredData = __searchAndFilterRows(elemTable.__tableData.columns, data, searchText, filters);
    __populateRows(filteredData, data, rowSelect, elemTable, tableBody, isGrouped);
    return filteredData;
}

// eslint-disable-next-line no-unused-vars
function __setupFooter(elemTable) {

    // if (elemTable.__tableData.multiselect) {

    //     var tableFoot = document.createElement('tfoot');
    //     {
    //         var tr = __createElement('tr', null, null);
    //         {
    //             var td = __createElement('td', null, null);
    //             td.colSpan = "" + tableData.columns.length;
    //             {
    //                 var span = __createElement('span', null, null);
    //                 {
    //                     var label = __createElement('label', null, 'Check/uncheck all');
    //                     {
    //                         var input = __createElement('input', null, null);
    //                         input.type = 'checkbox';
    //                         label.appendChild(input);

    //                         var spanCheck = __createElement('span', null, null);
    //                         label.appendChild(spanCheck);
    //                     }
    //                     span.appendChild(label);  
    //                 }
    //                 td.appendChild(span); 
    //             }
    //             tr.appendChild(td);
    //         }
    //         tableFoot.appendChild(tr);
    //     }
    //     table.appendChild(tableFoot);
    // }
}

function __setupHead(elemTable) {

    // console.log(`MagstimTable.__setupHead`, elemTable);

    const tableHead = document.createElement('thead');
    const tableHeadRow = document.createElement('tr');
    __setupColumnHeaders(elemTable, tableHeadRow, elemTable.__tableData.columns);
    tableHead.appendChild(tableHeadRow);
    elemTable.appendChild(tableHead);
}

function __setupBody(elemTable, isGrouped, addNoDataWhenEmpty) {
    var tableBody = document.createElement('tbody');
    elemTable.appendChild(tableBody);

    if (0 === elemTable.__sortButtons.length) {
        __setupRows(elemTable, tableBody, undefined, undefined, isGrouped, addNoDataWhenEmpty);
    }
    else {
        // Rather than setting up the view, we'll just sort on the first column
        elemTable.__sortButtons[0].click(); // this 
    }
}

export function initGroupedTable(divTable, tableData, heightPx, addNoDataWhenEmpty) {
	__initTable(divTable, tableData, heightPx, true, addNoDataWhenEmpty);
}

export function initTable(divTable, tableData, heightPx, addNoDataWhenEmpty) {
	__initTable(divTable, tableData, heightPx, false, addNoDataWhenEmpty);
}

function __initTable(divTable, tableData, heightPx, isGrouped, addNoDataWhenEmpty) {

    // console.log(`MagstimTable.__initTable heightPx=${heightPx} isGrouped=${isGrouped}`, tableData);
 
    tableData.isGrouped = isGrouped;
    tableData.addNoDataWhenEmpty = addNoDataWhenEmpty;

    if (process.env.NODE_ENV !== "production") {
        // No need to do this a non-production environment, development aid only...
        // Check that the supplied data is of the correct type
        __validateData(tableData, isGrouped);
    }

    if (typeof divTable === 'string' || divTable instanceof String) {
        divTable = document.getElementById(divTable);
    }
 
    if (undefined === addNoDataWhenEmpty) {
        addNoDataWhenEmpty = false;
    }

    if (addNoDataWhenEmpty) {

        if ((undefined === tableData.data) || (null === tableData.data)) {
            tableData.data = [];
        }

        if (0 === tableData.data.length) {
            const columns = tableData.columns;
            
            var noDataItem = {};

            columns.forEach(column => {

                if ((undefined !== column.formatter) && (null !== column.formatter)) {
                    column.formatter = undefined;
                }
               
                noDataItem[column.property] = CurrentLang().no_data_words;

            });

            tableData.data.isGrouped = false;
            tableData.isGrouped = false;
            isGrouped = false;
            
            tableData.data.push(noDataItem);
        }
    }

    // Setup the defaults for any optional args. 
    // This makes it easier, as it's then clear in the debugger what fields we use, and we don't need to check for undefined everywhere.
    if (undefined === tableData.multiselect) { tableData.multiselect = false; }
    if (undefined === tableData.singleselect) { tableData.singleselect = false; }
    if (undefined === tableData.select) { tableData.select = {}; }
    if (undefined === tableData.showSelectAtStart) { tableData.showSelectAtStart = false; }
    if (undefined === tableData.select.checked) { tableData.select.checked = { icon: 'fas fa-check-square', color: '#3B86FF' }; }
    if (undefined === tableData.select.unchecked) { tableData.select.unchecked = { icon: 'fas fa-square', color: '#B0D4F1' }; }

    tableData.rowSelect = tableData.multiselect || tableData.singleselect;

    if (undefined === divTable.style) {
        divTable.style = {};
    }

    divTable.style.overflow = 'hidden';
    divTable.style.background = 'transparent';

    const divTableWrapper = document.createElement('div');
    divTableWrapper.className = 'table-wrapper';

    const divTableScroll = document.createElement('div');
    divTableScroll.className = 'table-scroll';

    // if (tableData.multiselect) {
    //     divTableScroll.style.marginBottom = '30px';
    // }

    divTableScroll.style.height = (heightPx - 30) + 'px';
    const table = document.createElement('table');
    table.__tableData = tableData;
    __setupHead(table);
    __setupBody(table, isGrouped, addNoDataWhenEmpty);
    __setupFooter(table);

    divTableScroll.appendChild(table);
    divTableWrapper.appendChild(divTableScroll);

    const divTableWrappers = divTable.getElementsByClassName('table-wrapper');

    const divExistingTableWrapper = (divTableWrappers.length > 0) ? divTableWrappers[0] : undefined;

    divTable.appendChild(divTableWrapper);

    if (undefined !== divExistingTableWrapper) {
        divTable.removeChild(divExistingTableWrapper);
    }
}

function __validateRow(row, columns) {
    for (var x = 0; x < columns.length; x++) {
        const column = columns[x];
        if ((undefined === column.optional) && !column.optional) {
            const value = row[column.property];
            if ((undefined === value) || (null === value)) {
                // Check we are not a grouped table
                if(row.groupName === null || row.groupName === undefined){
                    //throw new Error('Data supplied (' + row + ') missing non-optional field ' + column.property);
                    console.log(`WARNING Data supplied missing non-optional field '${column.property}`, row)
                }
            }
        }
    }
}

function __validateData(config, isGrouped) {
    for (var x = 0; x < config.data.length; x++) {
        if ((undefined !== isGrouped) && (null !== isGrouped) && isGrouped) {
            var groupData = config.data[x];
            for (var y = 0; y < groupData.data.length; y++) {
                __validateRow(groupData.data[y], config.columns);
            }
        }
        else {
            __validateRow(config.data[x], config.columns);
        }
    }
}

function __getTable(divTable) {
    // console.log('__getTable divTable=' + divTable);
    if (typeof divTable === 'string' || divTable instanceof String) {
        divTable = document.getElementById(divTable);
        // console.log('__getTable divTable=' + divTable);
    }
    const divScroll = __getTableScroll(divTable);
    // console.log('__getTable divScroll=' + divScroll);

    var table;

    if (undefined !== divScroll) {
        table = divScroll.getElementsByTagName('table')[0];
    }
    // console.log('__getTable table=' + table);

    return table;
}

function __getTableScroll(divTable) {
    // console.log('__getTableScroll divTable=' + divTable);
    const tableWrapper = divTable.getElementsByClassName('table-wrapper')[0];
    // console.log('__getTableScroll tableWrapper=' + tableWrapper);

    var divScroll;

    if (undefined !== tableWrapper) {
        divScroll = tableWrapper.getElementsByClassName('table-scroll')[0];
    }

    // console.log('__getTableScroll divScroll=' + divScroll);

    return divScroll;
}

export
    function setHeight(divTable, heightPx) {

    console.log(`MagstimTableControl.setHeight(${divTable}, ${heightPx})`);

    if (typeof divTable === 'string' || divTable instanceof String) {
        divTable = document.getElementById(divTable);
    }

    // The header is 30px high
    __getTableScroll(divTable).style.height = (heightPx - 30) + 'px';
}

export function add(divTable, item) {
    const elemTable = __getTable(divTable);
    __validateRow(item, elemTable.__tableData.columns);
    elemTable.__tableData.data.push(item);
    __refreshRowsWithGlobalFilters(elemTable);
}

export function resetFilters(divTable) {
    const elemTable = __getTable(divTable);
    elemTable.__SearchText = null;
    elemTable.__Filters = {};
    // log(elemTable, `resetFilters(${divTable})`);

    if (undefined !== elemTable) {
        const sortButton = elemTable.__sortButtons[0];
        sortButton.className = __SORT;
        elemTable.__sortButtons[0].click();
    }
}

export
    function clear(divTable) {
    const table = __getTable(divTable);
    if (undefined !== table) {
        table.__tableData.data.length = 0;
        resetFilters(table);
    }
}

function log(elemTable, text) {
    console.log(text, elemTable.__SearchText, elemTable.__Filters, elemTable);
}

export function search(divTable, searchText) {

    const elemTable = __getTable(divTable);
    if (undefined !== elemTable) {
        elemTable.__SearchText = searchText; 
        // log(elemTable, `search(${divTable},${searchText})`);
        __refreshRowsWithGlobalFilters(elemTable);
    }
    else {
        console.log(`search(${divTable},${searchText}) table not defined yet`);
    }
}

export function getFilteredData(divTable) {
    const table = __getTable(divTable);
    if (table.__tableData.isGrouped) {
        var retVal = [];
        for (var x = 0; x < table.__tableData.data.length; x++) {
            const item = table.__tableData.data[x];
            retVal = retVal.concat(item.filteredData);
        }
        console.log(`getFilteredData(${divTable}) isGrouped=${table.__tableData.isGrouped} `, retVal);
        return retVal;
    }
    else {
        console.log(`getFilteredData(${divTable}) isGrouped=${table.__tableData.isGrouped} `, table.__tableData.filteredData);
        return table.__tableData.filteredData;
    }
}

export function getColumns(divTable) {
    const table = __getTable(divTable);
    if(table && table.__tableData){
        return table.__tableData.columns;
    }
}